
  // `indeterminate` is a DOM property with no HTML attribute, so the mixed
  // state has to be applied after render for it to be programmatic.
  export default {
    mounted() {
      this.syncMixedState()
    },
    updated() {
      this.syncMixedState()
    },
    syncMixedState() {
      this.el.indeterminate = this.el.dataset.indeterminate === "true"
    },
  }
